import React from 'react'
import {Button, Row, Col, Glyphicon, FormControl, Modal, Form, Panel} from 'react-bootstrap'
import Component from '../../components/AscComponent'
import CommonTable from '../../containers/Elements/Table/CommonTable'
import CustomerModal from './CustomerModal'
import * as GlobalConst from '../../components/AscConstants';
import AscConfirm from '../../components/Modal/AscConfirm';

export default class Customer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // table item
            columns:          this.getColumnsData(),
            data:             [],
            filtered: [],
            pages:            null,
            loading:          false,

            // modal item
            show:             false,
            modalType:        null,
            errShow:          false,
            errText:          "",

            // select item
            companySelect: [],

            // csv format
            csvHeader: [
                this.props.langText.Body.CustomerCsvTel,
                this.props.langText.Body.CustomerCsvCompanyName,
                this.props.langText.Body.CustomerCsvUserFirstName,
                this.props.langText.Body.CustomerCsvUserLastName,
                this.props.langText.Body.CustomerCsvUserFirstNameKana,
                this.props.langText.Body.CustomerCsvUserLastNameKana,
                this.props.langText.Body.CustomerCsvUserMailAddress,
                this.props.langText.Body.CustomerCsvTel2,
                this.props.langText.Body.CustomerCsvTel3,
                this.props.langText.Body.CustomerCsvTel4,
                this.props.langText.Body.CustomerCsvTel5,
                this.props.langText.Body.CustomerCsvTel6,
                this.props.langText.Body.CustomerCsvTel7
            ],

            // data item
            company_id:          '',
            companyName:         '',
            customerId:          '',
            firstNameCc:         '',
            lastNameCc:          '',
            firstNameKana:       '',
            lastNameKana:        '',
            customerCompanyName: '',
            mailAddress:         '',
            telNo:               [],
            telType:             [],
            csvFile:             [],
            originalCsvFile:     null, // 元のFileオブジェクトを保持
            csvParsingInProgress: false, // CSV解析中フラグ
            csvCount:            0,

            // button_disabled
            buttondisabledArr: {
                "company_id" : []
            },

            // 追加確認ポップアップ表示のON/OFF
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: "",
            confirmValue: "",
            
            // 顧客情報
            sendCustomerInfo: []
            
        }
    }

    componentDidMount = async () => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        } catch (err) {
            console.error(err);
            this.isTargetShowAddingConfirmationPopup = false;
        }


    }

    getColumnsData() {
        let itemArr = [];
        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: 'id',
            filterable: false,
            width: this.props.boardWidth.id,
        });
        // oem以上は会社カラム表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: 'cm12_companies.company_name',
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")} />
            });
        }
        itemArr.push({
            Header: this.props.langText.Body.CustomerCompanyName,
            accessor: 'company_name',
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "company_name")} />
        });
        itemArr.push({
            Header: this.props.langText.Body.FirstNameCc,
            accessor: 'first_name',
            width: this.props.boardWidth.UserName,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "first_name")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.LastNameCc,
            accessor: 'second_name',
            width: this.props.boardWidth.UserName,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "second_name")} />
        });
        itemArr.push({
            Header: this.props.langText.Body.Telno,
            accessor: 'ct01_customer_number.tel_no',
            width: this.props.boardWidth.CallNumber,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "ct01_customer_number.tel_no")} />
        });
        itemArr.push({
            Header: this.props.langText.Body.EmailAddress,
            accessor: 'mail_address',
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "mail_address")} />
        });
        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.Control,
            Cell: data => {
                let rowData = [];

                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            onClick={this.modalShow('update', data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="pencil"/>
                        </Button>
                    )
                } else {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            className="control-button"
                            onClick={this.modalShow("read", data.row._original)}
                        >
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            onClick={this.modalShow('delete', data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="minus"/>
                        </Button>
                    )
                }

                return (
                    <Row className="text-center">
                        {rowData}
                    </Row>
                )
            }
        });

        return itemArr;
    }

    // 画面表示タイミング共通処理_変数初期化
    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
    
            break;
        }
    }

    modalShow = (modalType, param) => async event => {
        event.preventDefault()

        this.modalshow_commonInit();

        let setData = {
            customerId: param && param.id
                ? param.id
                : "",
            company_id: param && param.cm12_companies && param.cm12_companies.id
                ? param.cm12_companies.id
                : "",
            companyName: param && param.cm12_companies && param.cm12_companies.company_name
                ? param.cm12_companies.company_name
                : "",
            customerCompanyName: param && param.company_name
                ? param.company_name
                : "",
            firstNameCc: param && param.first_name
                ? param.first_name
                : "",
            lastNameCc: param && param.second_name
                ? param.second_name
                : "",
            firstNameKana: param && param.first_name_kana
                ? param.first_name_kana
                : "",
            lastNameKana: param && param.second_name_kana
                ? param.second_name_kana
                : "",
            mailAddress: param && param.mail_address
                ? param.mail_address
                : "",
            csvFile: [],
            originalCsvFile: null, // 元のFileオブジェクトもリセット
            csvParsingInProgress: false, // CSV解析フラグもリセット
        }
        // 新規作成時にcompany以下なら会社固定
        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
            setData.company_id = this.props.userInfo.company_id
            setData.companyName = this.props.userInfo.company_name
            setData.floor_flg = this.props.userInfo.floor_flg
        }

        // 追加確認ポップアップ設定を取得
        setData.isSetShowAddingConfirmationPopup =
            setData.company_id !== ""
                ? await this.getIsShowAddingConfirmationPopup(setData.company_id)
                : false
            ;

        this.setState(setData);

        this.getCompanySelect()

        this.getAllTelNo(setData)

        this.setState({show: true, modalType})

    }

    onClickHandle = modalType => async event => {
        let {
            customerId,
            company_id,
            firstNameCc,
            lastNameCc,
            firstNameKana,
            lastNameKana,
            customerCompanyName,
            mailAddress,
            telNo,
            csvFile,
            isSetShowAddingConfirmationPopup,
            confirmMemo,
            sendCustomerInfo
        } = this.state

        sendCustomerInfo = this.getConfirmKeyItem(modalType);

        // 追加確認ポップアップの表示条件チェック
        if (
            this.isTargetShowAddingConfirmationPopup &&
            isSetShowAddingConfirmationPopup
        ) {
            // 追加確認ポップアップを表示すべき場合
            if (!this.state.showConfirm) {
                // 初回ボタン押下時：追加確認ポップアップを表示
                this.onClickConfirm(event, true);
                return;
            }
        } else {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            if (modalType === 'csvInsert') {
                // 未解析なら解析完了を待つ
                await this.ensureCsvParsed();
            }
            let popupItem = this.getCustomerTelNo();
            
            if (modalType === 'csvInsert') {
                // 通常ポップアップ用にCSVのデータ行数を表示（ヘッダー除外）
                popupItem = this.state.csvCount;
            }
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.CustomerInfo,
                popupItem,
                modalType
            )}`)) {
                return;
            }
        }

        switch (modalType) {
            case 'insert':
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/insert`, {
                        company_id: company_id,
                        first_name: firstNameCc,
                        second_name: lastNameCc,
                        first_name_kana: firstNameKana,
                        second_name_kana: lastNameKana,
                        customer_company_name: customerCompanyName,
                        mail_address: mailAddress,
                        tel_no: telNo,
                        sendCustomerInfo: sendCustomerInfo,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            this.props.langText.Message.DataInsertSuccess
                        )
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response?.data || err));
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })
                break

            case 'csvInsert':
                this.blockUI();
                let myForm = document.createElement("FORM");
                myForm.enctype = "multipart/form-data";

                let uploadForm = new FormData(myForm);
                uploadForm.append("company_id", company_id);
                // 解析済み配列ではなく、元のFileオブジェクトを送信
                uploadForm.append("files", this.state.originalCsvFile);
                uploadForm.append("confirmMemo", confirmMemo);
                uploadForm.append("sendCustomerInfo", sendCustomerInfo);

                this
                    .ascAxios('post', `${this.reactContainerPath}/csvInsert`, uploadForm)
                    .then(result => {
                        let message = [];
                        message.push(this.sprintf(this.props.langText.Message.SuccessDataCount, result.data.count));
                        message.push(this.sprintf(this.props.langText.Message.FailedDataCount, result.data.err.count));

                        if (result.data.err.count) {
                            result.data.err.body.forEach(row => {
                                message.push(`${this.sprintf(this.props.langText.Message.Line, row.line + 1)}${this.getErrorString(row)}`);
                            });

                            this.setState({
                                errShow: true,
                                errText: message.join("\r\n"),
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        } else {
                            alert(message.join("\r\n"));
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }

                        this.reactTableRefresh();
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response?.data || err));
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    });
                break

            case 'update':
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/update`, {
                        company_id: company_id,
                        customer_id: customerId,
                        first_name: firstNameCc,
                        second_name: lastNameCc,
                        first_name_kana: firstNameKana,
                        second_name_kana: lastNameKana,
                        customer_company_name: customerCompanyName,
                        mail_address: mailAddress,
                        tel_no: telNo,
                        sendCustomerInfo: sendCustomerInfo,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            this.props.langText.Message.DataUpdateSuccess
                        )
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response?.data || err));
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })

                break

            case 'delete':
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/delete`, {
                        customer_id: customerId,
                        company_id: company_id,
                        first_name: firstNameCc,
                        second_name: lastNameCc,
                        first_name_kana: firstNameKana,
                        second_name_kana: lastNameKana,
                        customer_company_name: customerCompanyName,
                        mail_address: mailAddress,
                        sendCustomerInfo: sendCustomerInfo,
                        tel_no: telNo,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            this.props.langText.Message.DataDeleteSuccess
                        )
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response?.data || err));
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })
         
                break

            default:
                alert(this.getErrorString({code: 'modal'}));
                this.setState({
                    show: false,
                    showConfirm: false,
                    confirmMemo: "",
                    confirmValue: ""
                });
                break;
        }
    }

    onMultiValueFormTextChange = (param, index, target, content) => {
        // 文字数制限処理追加
        if(content.length <= this.props.charaLimit.Customer_tag_tel)
        {
            let ArryTemp = this.state[param]

            if (target === 'tag') {
                ArryTemp[index].tag = content
            } else if (target === 'value') {
                ArryTemp[index].value = content
            }
            this.setState({[param]: ArryTemp})
        }
    }

    onMultiValueFormSizeChange = (param, handle, index) => {
        let ArryTemp = this.state[param]

        if (handle === 'plus') {
            let count = 0;
            ArryTemp.forEach(row => {
                if (!row.del_flag || row.del_flag !== "Y") {
                    count++;
                }
            });
            if (count < 5) {
                ArryTemp.push({id:null, tag:'', value:''});
            }
        } else if (handle === 'minus') {
            let count = 0;
            ArryTemp.forEach(row => {
                if (!row.del_flag || row.del_flag !== "Y") {
                    count++;
                }
            });
            if (count >= 2) {
                ArryTemp[index].del_flag = "Y";
            }
        }

        this.setState({[param]: ArryTemp})
    }

    getAllTelNo = ({customerId, company_id}) => {
        this
            .ascAxios('post', `${this.reactContainerPath}/getAllTelNoByCustomerId`, {
                customer_id: customerId,
                company_id: company_id
            })
            .then(res => {
                let tempArry = res.data.ct01_customer_number

                if (tempArry.length === 0) {
                    tempArry.push({id:null, tag:'', value:''})
                }

                this.setState({telNo: tempArry})
            })
            .catch(err => {
                alert(
                    this.getErrorString(err.response.data)
                )
            })
    }

    
    onSelectChange = (event, param) => {
        super.onSelectChange(event, param);
        let value = (event && event.value) ? event.value : "";

        if (param === "company_id") {
            // 会社選択時に追加確認ポップアップ設定を取得
            if (value) {
                this.getIsShowAddingConfirmationPopup(value).then((result) => {
                    this.setState({isSetShowAddingConfirmationPopup: result});
                }).catch(error => {
                    this.setState({isSetShowAddingConfirmationPopup: false});
                });
            } else {
                this.setState({isSetShowAddingConfirmationPopup: false});
            }
        }
    }

    getCompanySelect = () => {
        this.ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(res => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({
                    companySelect: res.data
                })
            })
            .catch(err => {
                alert(
                    this.getErrorString(err.response.data)
                )
            })
    }

    validationHandle = param => {
        let nowState   = null,
            validTelNo = /^[0-9]{1,}?$/

        let {
            firstNameCc,
            lastNameCc,
            company_id,
            telNo,
            csvFile,
        } = this.state

        switch (param) {
            case 'company_id':
                nowState = this.state[param]
                    ? null
                    : 'error'
                break

            case 'telNo':
                telNo.forEach(row => {
                    if (!row.del_flag || row.del_flag !== "Y") {
                        if (!validTelNo.test(row.value)) {
                            nowState = 'error'
                        }
                    }
                })
                break

            case "insert":
            case "update":
                nowState = (
                    company_id
                )

                telNo.forEach(row => {
                    if (!row.del_flag || row.del_flag !== "Y") {
                        if (!validTelNo.test(row.value)) {
                            nowState = false
                        }
                    }
                })
                break;
            case "delete":
                nowState = true;
                break;

            case "csvInsert":
                nowState = company_id && csvFile.length ? true : false
                break;

            default:
        }

        return nowState
    }

    getbtnValue = btn => {
        let btnvalue = btn.target.value;
        this.ascAxios('post',`Download/contentDL`, {param:btnvalue})
            .then(res=>{
                let templateURL = res.data.url;
                window.location.href=templateURL;

                // アクセスログ保存
                this.saveAccessLogs({
                    "resource" : `/Customer/contentDL`,
                    "body" : {
                        "template_type" : btnvalue,
                        "download_url" : templateURL
                    }
                });
            })
            .catch(err =>{
                alert(this.getErrorString(err));
            });
    };

    // CSVファイル解析メソッド
    parseCSVFile = (file) => {
        const encodings = ['UTF-8', 'Shift_JIS', 'EUC-JP'];
        let currentEncodingIndex = 0;

        const tryEncoding = (encoding) => {
            const reader = new FileReader();
            
            reader.onload = (event) => {
                try {
                    const csvText = event.target.result;
                    
                    // 文字化けチェック（簡易的な判定）
                    const hasGarbledText = csvText.includes('�') || csvText.includes('?');
                    
                    if (hasGarbledText && currentEncodingIndex < encodings.length - 1) {
                        // 次のエンコーディングを試行
                        currentEncodingIndex++;
                        tryEncoding(encodings[currentEncodingIndex]);
                        return;
                    }
                    
                    // CSVを行に分割（改行で分割）
                    const lines = csvText.split(/\r\n|\n|\r/);
                    // 各行をカンマで分割して2次元配列を作成
                    const csvData = lines
                        .filter(line => line.trim() !== '') // 空行を除外
                        .map(line => {
                            // カンマで分割（簡易的なCSV解析）
                            return line.split(',').map(cell => cell.trim());
                        });

                    // 解析されたCSVデータをstateに設定
                    this.setState({ 
                        csvFile: csvData,
                        csvParsingInProgress: false, // 解析完了フラグ
                        csvCount: csvData.length > 0 ? Math.max(0, csvData.length - 1) : 0 // データ行数（ヘッダー行を除く）
                    });

                } catch (error) {
                    console.error(error);
                    this.setState({ 
                        csvFile: [['CSVファイルの解析に失敗しました。ファイル形式を確認してください。']],
                        csvParsingInProgress: false, // エラー時もフラグリセット
                        csvCount: 0
                    });
                }
            };

            reader.onerror = (error) => {
                console.error(error);
                this.setState({ 
                    csvFile: [['']],
                    csvParsingInProgress: false, // エラー時もフラグリセット
                    csvCount: 0
                });
            };

            // 指定されたエンコーディングで読み取り
            reader.readAsText(file, encoding);
        };

        // 最初のエンコーディング（UTF-8）から開始
        tryEncoding(encodings[currentEncodingIndex]);
    }

    // CSVがFileListのままの場合、解析完了を待つ（最大10秒）
    ensureCsvParsed = async () => {
        const { csvFile, csvParsingInProgress } = this.state;
        if (!csvFile || !(csvFile instanceof FileList)) return;
        if (!csvParsingInProgress) {
            this.setState({
                csvParsingInProgress: true,
                originalCsvFile: csvFile[0]
            }, () => {
                this.parseCSVFile(csvFile[0]);
            });
        }
        await new Promise((resolve) => {
            const startedAt = Date.now();
            const timer = setInterval(() => {
                if (!this.state.csvParsingInProgress) {
                    clearInterval(timer);
                    resolve();
                } else if (Date.now() - startedAt > 10000) {
                    clearInterval(timer);
                    resolve();
                }
            }, 50);
        });
    }

    getCustomerTelNo = (isTarget = false) => {
        let customerTelNo = [];
        
        if (this.state.telNo && this.state.telNo.length > 0) {
            // del_flagが"Y"以外の電話番号のみ抽出
            const validPhoneNumbers = this.state.telNo
                .filter(telNo => !telNo.del_flag || telNo.del_flag !== "Y")
                .slice(0, 5);
            customerTelNo = validPhoneNumbers.map(telNo => telNo.value || "");
            // 5個未満の場合は'-'で埋める
            if(isTarget){
                while (customerTelNo.length < 5) {
                    customerTelNo.push('-');
                }
            }
        }

        return customerTelNo;
    }

    getConfirmKeyItem = (modalType) => {
        let displayArray = [];
            
        // ヘッダー設定：顧客名/ 電話番号1/電話番号2/電話番号3/電話番号4/電話番号5
        const headerColumns = [
            this.props.langText.Body.CustomerName,
            this.props.langText.Body.CustomerCsvTel,        // 電話番号1
            this.props.langText.Body.CustomerCsvTel2,       // 電話番号2
            this.props.langText.Body.CustomerCsvTel3,       // 電話番号3
            this.props.langText.Body.CustomerCsvTel4,       // 電話番号4
            this.props.langText.Body.CustomerCsvTel5        // 電話番号5
        ];

        displayArray.push(headerColumns); // 2次元配列：ヘッダー行

        // 顧客管理のCSV一括登録の場合
        if (modalType === 'csvInsert') {
            // CSVファイルの状態をチェック
            const isFileSelected = this.state.csvFile && this.state.csvFile.length > 0;
            const isFileListType = this.state.csvFile && this.state.csvFile instanceof FileList;
            const isDataParsed = this.state.csvFile && 
                                 this.state.csvFile.length > 0 && 
                                 !(this.state.csvFile instanceof FileList) &&
                                 this.state.csvFile[0] && 
                                 Array.isArray(this.state.csvFile[0]);

            // CSVファイルが選択されているがFileListの場合（まだ解析されていない）
            if (isFileListType) {
                // CSV解析がまだ開始されていない場合のみ解析を開始
                if (!this.state.csvParsingInProgress) {
                    this.setState({ 
                        csvParsingInProgress: true,
                        originalCsvFile: this.state.csvFile[0] // 元のFileオブジェクトを保存
                    }, () => {
                        this.parseCSVFile(this.state.csvFile[0]);
                    });
                }
                return displayArray;
            }
            
            // テーブル表示用の配列形式でデータを返す（解析済みデータの場合）
            const maxDisplayLimit = 5;
            const totalDataRows = this.state.csvFile.length - 1; // ヘッダー行を除いたデータ行数
            const displayCount = Math.min(totalDataRows, maxDisplayLimit);

            // CSVデータから顧客情報を取得（ヘッダー行をスキップして、index 1から開始）
            for (let i = 1; i <= displayCount; i++) {
                if (this.state.csvFile[i] && this.state.csvFile[i].length > 0) {
                    const rowData = this.state.csvFile[i];
                    
                    // CSV構造に基づくデータ取得（生データ）
                    const phone1Raw = rowData[0] || "";          // 電話番号
                    const companyName = rowData[1] || "";        // 顧客会社名
                    const lastName = rowData[2] || "";           // 顧客姓
                    const firstName = rowData[3] || "";          // 顧客名
                    const lastNameKana = rowData[4] || "";       // 顧客姓(カナ)
                    const firstNameKana = rowData[5] || "";      // 顧客名(カナ)
                    const phone2Raw = rowData[7] || '-';      // 電話番号2
                    const phone3Raw = rowData[8] || '-';      // 電話番号3
                    const phone4Raw = rowData[9] || '-';      // 電話番号4
                    const phone5Raw = rowData[10] || '-';     // 電話番号5
                    
                    // 顧客名の組み立て：漢字＜カナ＜会社名の順序で、値がある項目のみ表示
                    let customerName = "";
                    if (firstName && lastName) {
                        customerName = `${lastName} ${firstName}`;
                    } else if (firstNameKana && lastNameKana) {
                        customerName = `${lastNameKana} ${firstNameKana}`;
                    } else if (companyName) {
                        customerName = companyName;
                    } else {
                        customerName = '-';
                    }
                    
                    // データ行の組み立て：2次元配列形式
                    const dataRow = [customerName, phone1Raw, phone2Raw, phone3Raw, phone4Raw, phone5Raw];
                    displayArray.push(dataRow); // 2次元配列：データ行
                    
                }   
            }
            
            // データ行数が5件を超える場合は「他n件」を追加
            if (totalDataRows > maxDisplayLimit) {
                const remainingCount = totalDataRows - maxDisplayLimit;
                const otherCountText = this.props.langText.Body.OtherCount.replace('{0}', remainingCount);
                displayArray.push([otherCountText]); // 2次元配列：他n件行
            }
            return displayArray;
        } else {
            // 通常の登録・更新・削除の場合もテーブル形式で返す
            // 顧客名の組み立て
            let customerName = "";
            if (this.state.firstNameCc || this.state.lastNameCc) {
                customerName = `${this.state.firstNameCc} ${this.state.lastNameCc}`;
            } else if (this.state.firstNameKana || this.state.lastNameKana) {
                customerName = `${this.state.firstNameKana} ${this.state.lastNameKana}`;
            } else if (this.state.customerCompanyName) {
                customerName = this.state.customerCompanyName;
            } else {
                customerName = '-';
            }

            // 電話番号の取得とマスキング（del_flagが"Y"以外のみ表示、最大5件まで）
            let customerTelNo = this.getCustomerTelNo(this.state.isSetShowAddingConfirmationPopup);

            // データ行の組み立て：2次元配列形式
            const dataRow = [customerName, ...customerTelNo];
            displayArray.push(dataRow); // 2次元配列：データ行
            
            return displayArray;
        }
    }

    render() {
        return (
            <div className='Customer'>
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id="customer-insert"
                                className='table-button'
                                bsStyle='default'
                                bsSize='sm'
                                onClick={this.modalShow('insert')}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                            <Button
                                id="customer-csvInsert"
                                className='table-button'
                                bsStyle='default'
                                bsSize='sm'
                                onClick={this.modalShow('csvInsert')}>
                                {this.props.langText.Body.CustomerCsvImport}
                            </Button>
                        </Col>
                    }

                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = 'manual'
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}
                        />
                    </Col>
                </Row>

                <CustomerModal
                    getScopeGreaterEqual = {this.getScopeGreaterEqual}
                    currentPermission = {this.props.currentPermission}
                    state = {this.state}
                    propSetState = {this.propSetState}
                    langText = {this.props.langText}
                    charaLimit = {this.props.charaLimit}
                    onClick = {this.onClickHandle}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    onSelectChange = {this.onSelectChange}
                    onMultiSelectChange = {this.onMultiSelectChange}
                    onCheckBoxChange = {this.onCheckBoxChange}
                    onMultiValueFormTextChange = {this.onMultiValueFormTextChange}
                    onMultiValueFormSizeChange = {this.onMultiValueFormSizeChange}
                    onFileChange = {this.onFileChange}
                    validationHandle = {this.validationHandle}
                    getbtnValue={this.getbtnValue}/>

                <Modal
                    show = {this.state.errShow}
                    bsSize = "large"
                    aria-labelledby = "contained-modal-title-lg">
                    <Form horizontal={true}>
                        <Modal.Header>
                            <Modal.Title>
                                {this.props.langText.Body.CustomerCsvImport}
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Panel bsStyle="info">
                                <Panel.Body>
                                    <FormControl
                                        id="errTextarea"
                                        componentClass="textarea"
                                        rows="8"
                                        onChange={e => this.onTextChange(e, "errText")}
                                        value={this.state.errText}/>
                                </Panel.Body>
                            </Panel>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col className="panel-button pull-right">
                                    <Button
                                        className = 'cancel-execute-btn'
                                        onClick = {e => this.setState({errShow: false})}
                                        variant = 'outline-secondary'>
                                        {this.props.langText.Body.Cancel}
                                    </Button>
                                    <Button
                                        className = 'ok-execute-btn'
                                        bsStyle = "primary"
                                        onClick = {e => {
                                            const myText = document.getElementById("errTextarea");

                                            myText.select();
                                            document.execCommand("copy");
                                        }}>
                                        {this.props.langText.Body.Copy}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* 追加確認ポップアップ */}
                {
                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        key={this.state.modalType}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onClick = {this.onClickHandle}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        confirmKey = {this.props.langText.Body.CustomerInfo}
                        confirmKeyItem = {this.getConfirmKeyItem(this.state.modalType)}
                        sprintf = {this.sprintf}
                        customBtn1Func = {this.onClickConfirm}
                    />
                }
            </div>
        )
    }
}